import React, { useState, useEffect } from "react";
import {
  Redirect,
  Route,
  Link,
  useHistory,
  useLocation,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import { Modal, Button, Alert } from "react-bootstrap";
import api from "services/api";
import ProgressBar from "react-bootstrap/ProgressBar";
import RemainintTime from "elements/RemainingTime";
import { __ } from "services/Translator";

export default function WheelOfFortune(props) {
  const [fortuneWheel, setFortuneWheel] = useState(null); //THe database object of the wheel data
  const [wheelResult, setWheelResult] = useState(null);

  const [theWheel, setTheWheel] = useState(null); //The wheel object
  const [wheelSpinning, setWheelSpinning] = useState(null);
  const [wheelImage, setWheelImage] = useState(new Image());
  const [winMessage, setWinMessage] = useState({ message: "", show: false });

  const wheelImagePaths = {
    diamond: require("assets/images/wheelOfFortune/diamond-wheel.png").default,
    gold: require("assets/images/wheelOfFortune/gold-wheel.png").default,
    silver: require("assets/images/wheelOfFortune/silver-wheel.png").default,
    bronze: require("assets/images/wheelOfFortune/bronze-wheel.png").default,
  };

  const closeAllModals = () => {
    setWinMessage({ ...winMessage, show: false });
  };

  useEffect(() => {
    const tweenmax = document.createElement("script");
    const winwheel = document.createElement("script");
    tweenmax.src =
      "https://cdnjs.cloudflare.com/ajax/libs/gsap/latest/TweenMax.min.js";
    winwheel.src = "/js/Winwheel.js";
    document.body.appendChild(tweenmax);
    document.body.appendChild(winwheel);
    winwheel.addEventListener("load", () => {
      getWheelOfFortune();
    });
  }, []);

  const getWheelOfFortune = async () => {
    if (props.usePropsWheel.wheel) {
      //If wheel object is passed from caller component, use that instead
      setFortuneWheel(response.data);
    } else {
      var response = await api.get("/rewards/fortune-wheel/status");
      if (response.status === 200) {
        if (response.data) {
          setFortuneWheel(response.data.wheel);
          setWheelResult(null);
        } else {
          setFortuneWheel(null);
        }
      } else {
        setFortuneWheel(null);
      }
    }
  };

  const playSound = () => {
    // Create audio object and load tick.mp3 file.
    var audio = new Audio(require("assets/sounds/tick.mp3").default);
    // Stop and rewind the sound if it already happens to be playing.
    audio.pause();
    audio.currentTime = 0;
    // Play the sound.
    audio.play();
  };

  const alertPrize = (indicatedSegment) => {
    setWinMessage({
      ...winMessage,
      show: true,
      message:
        __("You have won") +
        " " +
        indicatedSegment.text +
        " " +
        __("of your wagers from yesterday."),
    });
    setTimeout(function () {
      resetWheel();
      getWheelOfFortune();
    }, 5000);
  };

  const resetWheel = () => {
    theWheel.stopAnimation(false); // Stop the animation, false as param so does not call callback function.
    theWheel.rotationAngle = -16;
    theWheel.wheelImage = wheelImage;
    theWheel.draw(); // Call draw to render changes to the wheel.
    setWheelSpinning(false);
    setTheWheel(theWheel);
  };

  const initWheel = () => {
    const Winwheel = window.Winwheel;
    var wheelConfig = {
      numSegments: 12, // Specify number of segments.
      outerRadius: 253, // Set outer radius so wheel fits inside the background.
      drawMode: "image", // drawMode must be set to image.
      drawText: true, // Need to set this true if want code-drawn text on image wheels.
      textFontSize: 0, // Set text options as desired.
      textOrientation: "curved",
      textDirection: "normal",
      textAlignment: "outer",
      textMargin: 35,
      textFontFamily: "monospace",
      textStrokeStyle: "black",
      textLineWidth: 2,
      textFillStyle: "white",
      rotationAngle: -16,
      // pointerAngle: 16,
      // Define segments.

      segments: fortuneWheel.fortune_type.fortune_prizes.map((item, index) => {
        return { text: item.title };
      }),
      // Specify the animation to use.
      animation: {
        type: "spinToStop",
        duration: 10, // Duration in seconds.
        spins: 10, // Number of complete spins.
        callbackSound: playSound,
      },
    };

    var wheel = new Winwheel(wheelConfig);
    wheelImage.width = 510;
    wheelImage.height = 510;
    // console.log("wheelImage", wheelImage);

    wheelImage.src = wheelImagePaths[fortuneWheel.fortune_type.slug];
    setWheelImage(wheelImage);
    setTheWheel(wheel);
  };

  const startSpin = async () => {
    if (!wheelSpinning) {
      setWheelSpinning(true);
      var response = await api.post("/rewards/fortune-wheel/spin", {
        player_fortune_id: fortuneWheel.id,
      });
      if (response.status === 200) {
        if (response.data) {
          setWheelResult(response.data);
          theWheel.animation.stopAngle = response.data.win_point;
          theWheel.animation.callbackFinished = alertPrize;
          theWheel.startAnimation();
        } else {
          setWheelSpinning(false);
          setWheelResult(null);
        }
      } else {
        setWheelSpinning(false);
        setWheelResult(null);
      }
    }
  };

  useEffect(() => {
    if (fortuneWheel) {
      initWheel();
    }
  }, [fortuneWheel]);

  useEffect(() => {
    if (wheelImage && theWheel) {
      wheelImage.onload = function () {
        theWheel.wheelImage = wheelImage;
        theWheel.draw();
        setTheWheel(theWheel);
      };
    }
  }, [wheelImage, theWheel]);

  return (
    <>
      <div class="c-wheel">
        <a href="javascript:;" class="c-wheel__btn-close"></a>{" "}
        <div class="c-wheel__inner o-ratio o-ratio--1:1">
          <div
            data-hj-suppress=""
            class="c-wheel__spinner o-ratio__content"
            style={{ transition: "transform 9s ease-in-out" }}
          >
            <div class="c-wheel__segment-list">
              <div class="c-wheel__segment">
                <div class="c-wheel__item-label">8,400</div>
              </div>
              <div class="c-wheel__segment">
                <div class="c-wheel__item-label">10,500</div>
              </div>
              <div class="c-wheel__segment">
                <div class="c-wheel__item-label">12,600</div>
              </div>
              <div class="c-wheel__segment">
                <div class="c-wheel__item-label">14,700</div>
              </div>
              <div class="c-wheel__segment">
                <div class="c-wheel__item-label">16,800</div>
              </div>
              <div class="c-wheel__segment">
                <div class="c-wheel__item-label">18,900</div>
              </div>
              <div class="c-wheel__segment">
                <div class="c-wheel__item-label">21,000</div>
              </div>
              <div class="c-wheel__segment">
                <div class="c-wheel__item-label">23,100</div>
              </div>
              <div class="c-wheel__segment">
                <div class="c-wheel__item-label">25,200</div>
              </div>
              <div class="c-wheel__segment">
                <div class="c-wheel__item-label">27,300</div>
              </div>
            </div>
          </div>{" "}
          <div class="c-wheel__bg"></div> <div class="c-wheel__cta"></div>
        </div>
      </div>
    </>
  );
}
